import * as React from 'react'
import { connect } from 'react-redux'
import Breadcrumbs from '../Breadcrumbs.component'

class ReportNewAccident extends React.PureComponent {
  render() {
    return (
      <div>
        <Breadcrumbs breadcrumbs={[
          { name: 'Accidents', link: '/accidents' },
          { name: 'Reports', active: true },
        ]} />
        <div className="px-3">
          <h3>Reports</h3>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({accidents}) => ({
})

const mapDispatchToProps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(ReportNewAccident)


// WEBPACK FOOTER //
// ./src/routes/accidents/AccidentReports.page.tsx